import { useMemo, type FC } from 'react';

import Grid2 from '@mui/material/Unstable_Grid2';

import ChipTaskCheckStatus from '@/components/chip/ChipTaskCheckStatus';
import TextAction from '@/components/text-action/TextAction';
import { DisplayField } from '@/components/typography/DisplayField';
import { DEFAULT_DISPLAY } from '@/constants/default-value/default-value';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';

const ReminderScheduleInfo: FC<{ data: any }> = ({ data: detail }) => {
    console.log('detail', detail);

    const info = useMemo(
        () => [
            {
                id: 1,
                title: (
                    <TextAction value={detail?.code} copy>
                        {t('Mã Task')}
                    </TextAction>
                ),
                value: detail?.code,
            },
            {
                id: 2,
                title: 'Tên Task',
                value: detail?.name,
            },
            {
                id: 3,
                title: 'Ngày bắt đầu',
                value:
                    detail?.scheduledTime &&
                    dateUtils.getDate(detail?.scheduledTime),
            },
            {
                id: 4,
                title: 'Loại phiếu',
                value: detail?.templateCheck?.name,
            },
            {
                id: 5,
                title: ['Trạng thái', 'TaskDetail'],
                value: (
                    <ChipTaskCheckStatus
                        status={detail?.taskCheckStatus ?? 'default'}
                    />
                ),
            },
            {
                id: 6,
                title: 'Ngày tạo',
                value:
                    detail?.createdDate &&
                    dateUtils.getDate(detail?.createdDate),
            },
        ],
        [detail]
    );

    return (
        <Grid2 container spacing={5}>
            {info.map(({ id, title, value }) => {
                return (
                    <DisplayField
                        key={id}
                        label={title ? title : DEFAULT_DISPLAY}
                        value={value}
                    />
                );
            })}
        </Grid2>
    );
};

export default ReminderScheduleInfo;
